import { render, staticRenderFns } from "./OrganizationDrive.vue?vue&type=template&id=240818c5&scoped=true&"
import script from "./OrganizationDrive.vue?vue&type=script&lang=js&"
export * from "./OrganizationDrive.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDrive.vue?vue&type=style&index=0&id=240818c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240818c5",
  null
  
)

export default component.exports